/*-----------------------------------------------------------------------------/
/ TODO:
/-----------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------/
/ Custom Liquid
/-----------------------------------------------------------------------------*/

// cart-free-shipping-bar.liquid
//    Added BYOC message in free shipping bar

// section-custom.liquid
//   Added a Project 7 Archive anchor tag. This allows navigation from the archive beer page back to the project 7 landing page archive section

//cart-drawer.liquid
//   To remove the free shipping bar for products with keywords
//   To hide the free shipping bar by using keywords in the product title
//   Adds BYOC message to drawe

//main-cart.liquid
//  To remove the free shipping bar for products with keywords
//  Section added to display the number of items added from byoc collection

// cart-details.liquid
//  Over 18 verification before proceeding to the checkout
//  Hides ShopifyPay and GooglePay buttons. This was bypassing the T&C's and Age Verification checkboxes. ShopifyPay and GooglePay can be accessed in the checkout

//product-card.liquid
//  added to remove quick shop from the Project 7 Archive
//  added to remove Sold Out Label from the Project 7 Archive
//  added to remove price Label from the Project 7 Archive
//  Removes Quickshop icon for collections, pages or products
//  Added to put custom stylised text under products or collections. For example; Project 7 under each Project 7 product.

//quick-shop.liquid
// To remove the 'Shipping calculated as checkout' statement from quick shop

//product-price.liquid
// Removes 'Shipping calculated at Checkout' from products

//section-product-recommendations.liquid
// Remove the quick add button from recommendations, to prevents products that require a booking date from being added directly to the cart without selecting a date

//section-multi-column-images.liquid
//  Added to remove columns without images or videos. This is for the beer pages in the Trade section. The page template has every packaging format, but only displays the formats with images

//pdp-blocks.liquid
// Added line to remove free shipping bar, price and quantity selector from collections with tag. Currently used for keg and cask hire
// Removes ABV and IBU's for non applicable products

//cart-item.liquid
// Hide the remove and quantity buttons for products specified titles.

//theme.liquid
// Added Microsoft Clarity code snippet
// Added Bing Webmaster code snippet

//gift_card.liquid
//  Added custom image for online gift cards

// tabology-booking-widget.liquid
//  Added entire file to create a tabology booking widget

// scrion-events.liquid
// Commented out original code and added a line to allow customised link arrows

/*-----------------------------------------------------------------------------/
/ Custom CSS
/-----------------------------------------------------------------------------*/

// component-cart.css
//   Added pointer-events: none; to allow the link under the free-shipping-bar__animation to be clickable
//   Changed font size of .cart-item__qty quantity-input input[type=number], from 0.865rem to 0.85rem, to fit better in the cart quantity box

// section-announcement-bar.css
//   Centre announcement popup text

//global.css
//  Added to centre the project 7 archive title text
//  myColourStrip added
//  Code added to centre the products in a featured collection product grid
//  CSS added for _byoc checkout message
//  Spolier warning CSS

//base.css
// Changed the mono button colour to the Natural Selection Brewing 2025 colour scheme
// Events shown in a row of 3 in desktop screen instead of 2
// Changes colour of blog cards
// Removes gap above the Shop Shortcut Navigation. To add more pages, find the page ID add in ':not(#NEW-PAGE)' before '.main'

// component-blog.css
// Added custom setting to have blog posts sit within a card

/*-----------------------------------------------------------------------------/
/ Custom Javascript
/-----------------------------------------------------------------------------*/

//cart-components.js
// Updates the BYOC message if the quantity of BYOC products are changed

//cart-recommendations.js
//  Removes a product title from the cart recommendations. Currently used for _deposit, keg, cask, tour, ticket and brew it yourself. The cart recommendations bypass BTA

/*-----------------------------------------------------------------------------*/
/* UPDATE TESTS */
/*-----------------------------------------------------------------------------*/
// BYOC MESSAGE
// Does the BYOC message add the the cart drawer and cart *** PASS 2025-06-27 RW ***
// Is the 'Build Your Own Case collection!' link clickable in the cart drawer *** PASS 2025-06-27 RW ***
// Is the BYOC message visable in the cart with a keg or cask hire product *** PASS 2025-06-27 RW ***
// Does the number of items update automatically in the cart *** PASS 2025-06-27 RW ***

// MERCH FOOD ABV AND IBU'S
// Are the ABV and IBU's removed from merchandise food items *** PASS 2025-06-27 RW ***

// ANNOUNCEMENT BAR POP UPS
// On announement bar pop ups, is the text centred in the card  *** PASS 2025-06-27 RW ***

// PROJECT 7 ARCHIVE
// Are the prices, quick shop and sold out labels removed from Project 7 archive products, don't forget to check mobile view *** PASS 2025-06-27 RW ***
// Does the 'Back to the archive' button take you to the correct place *** PASS 2025-06-27 RW ***

// FREE SHIPPING BAR
// Is the free shipping bar removed from keg/cask hire products, tours and CBK *** PASS 2025-06-27 RW ***

// CART
//  T&C'S Are you prevented from checking out with ticking the T&C's field and the Over 18 field *** PASS 2025-06-27 RW ***
// BTA  products are not recommended *** PASS 2025-06-27 RW ***

// PRODUCT CARDS
//  Is the message 'Shipping calculated at checkout' removed from quickshop cards? *** PASS 2025-06-27 RW ***
// Are the product ranges added under the products name. For example, Project 7 *** PASS 2025-06-27 RW ***

// MIXED CASES
// In each mixed case, are the contents of the mixed case displayed as cards and are the styled *** PASS 2025-06-27 RW ***

// PRODUCT GRID
// Are products centred in the product grid *** PASS 2025-06-27 RW ***

// MENU LINKS
// The food menus open in a new tab and don't navigate away from our site *** PASS 2025-06-27 RW ***

// BLOG POSTS
// Blog cards are highlighted as you scroll past them *** PASS 2025-06-27 RW ***

/*-----------------------------------------------------------------------------*/
//SBCUSTOM: Addeed to open links in a new tab
const links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

//SBCUSTOM: Faded blog border in and out
document.addEventListener("DOMContentLoaded", function () {
  const blogCards = document.querySelectorAll(".blog");

  blogCards.forEach((blog) => {
    const tagLink = blog.querySelector(".blog__meta-tags__link");
    if (tagLink) {
      const tagText = tagLink.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      blog.classList.add(`blog--tag-${tagText}`);
    } else {
      blog.classList.add("blog--tag-default");
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const ratio = entry.intersectionRatio;

        if (ratio >= 0.7) {
          entry.target.classList.add("blog--in-view");
        } else if (ratio < 0.7) {
          entry.target.classList.remove("blog--in-view");
        }
      });
    },
    {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    }
  );

  blogCards.forEach((blog) => observer.observe(blog));
});